import SpeakButton from "@/components/SpeakButton";
import { useState } from "react";
import { Globe } from "lucide-react";
import { useT } from "@/i18n";
import { WEB_TEXT } from "@/components/webdev/content";

const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");

export default function DomainIdea() {
  const { lang } = useT();
  const tx = WEB_TEXT[lang];
  const [name, setName] = useState("");
  const base = slug(name);
  const ideas = base ? [`${base}.com`, `${base}.net`, `${base}kids.com`, `mi${base}.com`] : [];
  return (
    <div>
      <div className="flex flex-wrap items-center gap-2"><h3 className="font-fredoka text-xl sm:text-2xl font-bold text-blue-950">{tx.domainTitle}</h3><SpeakButton compact mascot="spark" text={tx.domainTitle} testId="ask-web-domain" /></div>
      <input
        value={name}
        onChange={(e) => setName(e.target.value)}
        maxLength={40}
        placeholder={tx.domainPh}
        className="mt-3 w-full bg-white border-4 border-white rounded-full px-5 py-3 font-semibold shadow-md focus:outline-none focus:ring-4 focus:ring-sky-300"
        data-testid="web-domain-input"
      />
      {ideas.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-3" data-testid="web-domain-ideas">
          {ideas.map((d) => (
            <span key={d} className="bg-yellow-200 border-4 border-white rounded-full px-4 py-2 font-fredoka font-bold text-blue-950 shadow-md inline-flex items-center gap-2">
              <Globe className="w-4 h-4" /> {d}
            </span>
          ))}
        </div>
      )}
      <p className="mt-3 text-sm font-semibold text-blue-900">{tx.domainNote}</p>
    </div>
  );
}
